import React from 'react';
import SEO from '@americanexpress/react-seo';
import { useIntl } from 'react-intl';
import { getActiveLocaleSelector } from '@americanexpress/travel-selectors';
import { useSelector } from 'react-redux';
import { useDataFromOneCMS } from '../../fetchye/useDataFromOneCMS';

const Seo = () => {
  const activeLocale = useSelector(getActiveLocaleSelector);
  const hotelCreditDescription = useDataFromOneCMS('seo.hotelCreditDescription');
  const hotelCreditTitle = useDataFromOneCMS('seo.hotelCreditTitle');
  const { formatMessage } = useIntl();

  return (
    <SEO
      title={hotelCreditTitle}
      description={hotelCreditDescription}
      canonical={{ __html: formatMessage({ id: 'hotelCreditUrl' }) }}
      twitterCard={{
        card: 'summary_large_image',
        site: '@AmericanExpress',
      }}
      robots={['index']}
      openGraph={{ __html: formatMessage({ id: 'siteName' }) }}
      locale={activeLocale}
    />
  );
};

export default Seo;
